export const MIN_SIDE_PANEL_WIDTH = 320;
export const MIN_ASSISTANT_RAIL_WIDTH = 200;
export const MIN_SOURCES_PANEL_WIDTH = MIN_ASSISTANT_RAIL_WIDTH;
export const DEFAULT_ASSISTANT_RAIL_WIDTH = 280;
export const DEFAULT_ASSISTANT_PANEL_WIDTH_RATIO = 1 / 3;
export const MAX_ASSISTANT_PANEL_WIDTH_RATIO = 0.8;
export const MIN_DOCUMENT_PREVIEW_RATIO = 0.2;
export const DEFAULT_SOURCES_PANEL_WIDTH_RATIO = 0.3;
export const MAX_SOURCES_PANEL_WIDTH_RATIO = 0.6;
export const COPY_FEEDBACK_MS = 1500;
export const SOURCE_CARD_FLASH_MS = 1600;
/** Synthetic href prefix for inline `[[n]]` citation chips in markdown. */
export const CITATION_LINK_PREFIX = '#ai-assistant-citation-';

export const AI_ASSISTANT_PANEL_WIDTH_VAR = '--ai-assistant-panel-width';
export const AI_ASSISTANT_RAIL_WIDTH_VAR = '--ai-assistant-rail-width';
